<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }"/>
    </template>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="3" v-for="i in icons" :key="i">
            <label class="icon c-pointer">
              <input v-model="pick" class="icon__input" type="radio" :value="i">
              <span class="icon__image">
                <v-badge class="icon__badge" overlap dot color="success" :value="pick === i">
                  <img :src="`${publicPath}icons/${i}`" :alt="i" width="100%">
                </v-badge>
              </span>
            </label>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">Select</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import icons from '@/utils/icons.json';

export default {
  name: 'icon-selector',
  props: {
    value: String,
  },
  data() {
    return {
      pick: '',
      dialog: false,
      selected: false,
    };
  },
  watch: {
    value() {
      if (!this.selected) this.pick = '';
      else this.selected = false;
    },
  },
  computed: {
    publicPath() {
      return process.env.VUE_APP_PUBLIC_PATH;
    },
    icons() {
      return icons;
    },
  },
  methods: {
    close() {
      this.selected = true;
      this.$emit('input', this.pick);
      this.dialog = false;
    },
  },
};
</script>
